import {
  Component,
  ChangeDetectionStrategy,
  ViewChild,
  TemplateRef,
  OnInit,
} from '@angular/core';
import {
  startOfDay,
  endOfDay,
  subDays,
  addDays,
  endOfMonth,
  isSameDay,
  isSameMonth,
  addHours,
  parseISO
} from 'date-fns';
import { map, mapTo, Subject, tap } from 'rxjs';
import {
  CalendarEvent,
  CalendarEventAction,
  CalendarEventTimesChangedEvent,
  CalendarView,
} from 'angular-calendar';
import { FunctionsService, HeaderFilters, HttpService, LocalStorageService, MessageService, params, SessionService } from 'brainloper-ui';
import { MatDialog } from '@angular/material/dialog';
import { Projection } from 'app/models2/maintenance/projection';
import { EndpointDictionary } from 'app/utils/endpoints-dictionary';
import { ModalCalendarComponent } from '../modal-calendar/modal-calendar.component';

const colors: any = {
  red: {
    primary: '#ad2121',
    secondary: '#FAE3E3',
  },
  blue: {
    primary: '#1e90ff',
    secondary: '#D1E8FF',
  },
  yellow: {
    primary: '#e3bc08',
    secondary: '#FDF1BA',
  },
};

function validTitle(equipo: string, componente: string) {
  let title: string
  if(componente == null){
    title=`Cogido ${equipo}`
  }else{
    title=`Equipo: ${equipo}, Componente: ${componente},`
  }
  return (title)

}

@Component({
  selector: 'app-calendar',
  templateUrl: './calendar.component.html',
  styleUrls: ['./calendar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  styles: [
    `
      h2 {
        margin: 0 0 10px;
      }

      pre {
        background-color: #f5f5f5;
        padding: 15px;
      }
    `,
  ],
})

export class CalendarComponent implements OnInit {

  public headerFilters: Array<HeaderFilters> = [
    {
      tN: "equipos",
      labelFilter:"Equipo",
      urlData: `${EndpointDictionary.Equipment.EQUIPMENT_COMBO}`,
      visibleField:"code",
      primaryKey:"id",
      type:"select",
      value:""
    },   {
      tN: "tipo_equipo",
      labelFilter:"Tipo equipo",
      urlData: `${EndpointDictionary.EquipmentType.EQUIPMENT_TYPE_COMBO}`,
      visibleField:"name",
      primaryKey:"id",
      type:"select",
      value:""
    }
  ]

  @ViewChild('modalContent', { static: true }) modalContent: TemplateRef<any>;

  view: CalendarView = CalendarView.Month;

  private urlGetProyecciones:string = `${EndpointDictionary.Proyection.PROYECTION_DATA}`
  private params:Array<params> = [{id:'activityId', value:'0'}]

  public CalendarView = CalendarView;
  public viewDate: Date = new Date();

  private modalData: {
    action: string;
    event: CalendarEvent;
  };

  public locale: string = 'es';

  private actions: CalendarEventAction[] = [
    {
      label: '<i class="fas fa-fw fa-pencil-alt"></i>',
      a11yLabel: 'Edit',
      onClick: ({ event }: { event: CalendarEvent }): void => {
        this.handleEvent('Edited', event);
      },
    },
    {
      label: '<i class="fas fa-fw fa-trash-alt"></i>',
      a11yLabel: 'Delete',
      onClick: ({ event }: { event: CalendarEvent }): void => {
        this.events = this.events.filter((iEvent) => iEvent !== event);
        this.handleEvent('Deleted', event);
      },
    },
  ];

  public refresh = new Subject<void>();

  public events: Array<CalendarEvent> = [];

  public recharge: boolean = true

  public activeDayIsOpen: boolean = true;

  constructor(
    private http: HttpService,
    public dialog: MatDialog) {
      //this.message.openLoading("Cargando", "Cargando...")
    }

  ngOnInit(): void {
    this.fetchEvents()
  }

  async applyFilters($event:Array<HeaderFilters>){
    await this.fetchEvents($event)
  }

  async fetchEvents(body?:Array<HeaderFilters>) {

    let today = new Date()
    let color:any
    this.events = []
    let res:Array<Projection> = body && body.length > 0
      ? await this.http.postDataBody(this.urlGetProyecciones, body, this.params)
      : await this.http.getDataBody(this.urlGetProyecciones, this.params)

    if(res){
      for(let element of res){

        const dateParts = element.projectDate.split('-');
        const year = parseInt(dateParts[0], 10);
        const month = parseInt(dateParts[1], 10) - 1;
        const day = parseInt(dateParts[2], 10);

        let maintenanceDate = new Date(year, month, day);

        color = isSameDay(today,maintenanceDate) ? colors.yellow : (maintenanceDate < today) ? colors.red : colors.blue;

        let title = validTitle(element.code, element.componentName)

        this.events.push({
          title: `${title} Descripcion: ${element.description}`,
          start: parseISO(element.projectDate),
          id: element.activityId,
          color: color,
          allDay: true,
          draggable: true
        })
      }

    }

    this.refresh.next();

}

  dayClicked({ date, events }: { date: Date; events: CalendarEvent[] }): void {
    if (isSameMonth(date, this.viewDate)) {
      if (
        (isSameDay(this.viewDate, date) && this.activeDayIsOpen === true) ||
        events.length === 0
      ) {
        this.activeDayIsOpen = false;
      } else {
        this.activeDayIsOpen = true;
      }
      this.viewDate = date;
    }
  }

  eventTimesChanged({
    event,
    newStart,
    newEnd,
  }: CalendarEventTimesChangedEvent): void {
    this.events = this.events.map((iEvent) => {
      if (iEvent === event) {
        return {
          ...event,
          start: newStart,
          end: newEnd,
        };
      }
      return iEvent;
    });
    this.handleEvent('Dropped or resized', event);
  }

  handleEvent(action: string, event: CalendarEvent): void {
    let size = 80
    if(screen.width<400 || screen.height<400){
      size = 85
    }


    this.dialog.open(ModalCalendarComponent,{
      data:event,
      width:`${size}vw`,
      height:`${size}vh`
    })
  }

  setView(view: CalendarView) {
    this.view = view;
  }

  closeOpenMonthViewDay() {
    this.activeDayIsOpen = false;
  }

  isSameDay(date1: Date, date2: Date): boolean {
    return date1.getFullYear() === date2.getFullYear() &&
           date1.getMonth() === date2.getMonth() &&
           date1.getDate() === date2.getDate();
  }

}
